import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { friendsList, referralList } from 'src/app/model/qde';
import { IwService } from 'src/app/services/iw.service';
import { WSCallDetailsData } from "src/app/model/creat-update-lead";
import { CompleteApplicationService } from 'src/app/services/complete-application.service';
import { Router } from '@angular/router';
import { GENERIC_ERROR, VALIDATION_MSG, REFER_TEXT, DOC_UPLOAD_LINK, IS_CAMPAIGN } from 'src/app/config/app-settings.config';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { ErrorStateMatcher } from '@angular/material';
import { Observable, Subscription } from 'rxjs';
import { ThemeService } from 'src/app/services/theme.service';
declare var AmoScript: Function;
declare var _satellite: any;
declare var form_next_click: Function;
declare var refer_submit: Function;
declare var analytics: any;


/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {

    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}

@Component({
  selector: 'app-skip-popup',
  templateUrl: './skip-popup.component.html',
  styleUrls: ['./skip-popup.component.scss']
})
export class SkipPopupComponent implements OnInit {
  matcher = new MyErrorStateMatcher();
  friendsListObj: friendsList;
  friendsList: any = [];
  wsDetails = new WSCallDetailsData();
  referfriendCompleteForm: FormGroup;

  skipModalVisible: boolean = true;
  referModalVisible: boolean = false;
  termsAndCondition: boolean = false;
  errorMessageReferral: any;

  public phoneregex: '[/^(?:(?:\+|0{0,2})91(\s*[\ -]\s*)?|[0]?)?[789]\d{9}|(\d[ -]?){10}\d$/]';
  eapplyFormPostQDELabel: any;
  referralObj: referralList;
  counter = 0;
  addFriendLimit: boolean = true;
  validationMsgs: any;
  refer_text: string;
  errorMessage: any;
  formValueNullFlag = true;
  disableService = 0;
  referralSubscription: Subscription;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');
  themeParam: any;

  constructor(
    public dialog: MatDialog,
    private fb: FormBuilder,
    private router: Router,
    private iw: IwService,
    private completeApp: CompleteApplicationService,
    private sharedData: SharedServiceService,
    private themeService: ThemeService) {
    this.partnerCode = this.themeService.partnerCode;
  }

  ngOnInit() {
    this.themeParam = this.themeService.themeParam;
    this.validationMsgs = VALIDATION_MSG;
    this.refer_text = REFER_TEXT;
    if (this.completeApp.submitClickedComp) {
      this.referModalVisible = true;
      this.skipModalVisible = false;
      this.termsAndCondition = false;
    }
    this.referForm();
    this.eapplyFormPostQDELabel = this.iw.geteapplyFormPostQDEDCR();
    this.referfriendCompleteForm.valueChanges.subscribe((obj) => {
      this.validateForm(obj);
    })
  }

  referForm() {
    this.referfriendCompleteForm = this.fb.group({
      fcnFullName: ['', [Validators.required, Validators.pattern("[A-Za-z\\s]*")]],
      fcnEmailAddress: ["", Validators.compose([Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:!#{}'?/|`~$%^&*+=\s@"]+(\.[^<>()\[\]\\.,;:!#{}'?/|`~$%^&*+=\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)])],
      fcnPhoneNumber: ["", Validators.compose([Validators.required, Validators.pattern("^([3-9]{1}[0-9]{9})$")])],
    })
  }

  alphabetsOnly(event) {
    let regex = "[A-Za-z\\s]*";
    if (event.key.match(regex)) {
      return true;
    } else {
      return false;
    }
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.referfriendCompleteForm.controls[controlName].hasError(errorName);
  }

  get f() {
    return this.referfriendCompleteForm.controls;
  }

  ReferenceDialog(): void {
    if (window['_satellite']) {
      _satellite.track("custom_link");
    }
    this.skipModalVisible = false;
    this.referModalVisible = true;



  }

  back() {
    if (window['_satellite']) {
      _satellite.track("custom_link");
    }
    this.docUploadCall();

    /* Analytics added */
    if (window['analytics']) {
      analytics.track('eapply__click__I_dont_want_to_refer', {
        'MODE_OF_CONVERSION': '',
        'IS_ORGANIC': 'N',
        'SOURCE_GEM_ID1': this.sharedData.paramsgemid1,
        'SOURCE_GEM_ID2': this.sharedData.paramsgemid2,
        'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
        'CHANNEL_NAME': this.sharedData.paramschannel,
        'JOURNEY_NAME': 'EAPPLY',
        'FIRST_NAME': this.sharedData.qdeSubmitData.WSCallUserFirstName,
        'LAST_NAME': this.sharedData.qdeSubmitData.WSCallUserLastName,
        'MIDDLE_NAME': this.sharedData.qdeSubmitData.WSCallUserMiddleName,
        'EMAIL': this.sharedData.qdeSubmitData.WSCallUserEmailId,
        'Mobile_no': this.sharedData.qdeSubmitData.WSCallUserMobileNumber,
        'pan': this.sharedData.qdeSubmitData.WSCallUserPanNumber,
        'DOB': this.sharedData.qdeSubmitData.WSCallUserDOB,
        'CARD_TYPE': this.sharedData.sbic_card_Type
      })
    }


  }

  trimObject(object) {
    object = Object.assign({}, object);
    let keys = Object.keys(object);
    keys.forEach(element => {
      if (typeof object[element] == "string" && object[element]) {
        object[element] = object[element].trim();
      } else if (typeof object[element] == "object" && object[element] && element != 'WSCallUserDOB' && element != 'dateOfBirth') {
        object[element] = this.trimObject(object[element]);
      }
    });
    return object;
  }

  addFriend(reset: FormGroupDirective) {
    if (window['_satellite']) {
      _satellite.track("custom_link");
    }

    let labelsDisplay: any;
    if (this.eapplyFormPostQDELabel) {
      if (this.eapplyFormPostQDELabel.referfullName_label) {
        labelsDisplay = this.eapplyFormPostQDELabel.referfullName_label
      } if (this.eapplyFormPostQDELabel.referemailAddress_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.referemailAddress_label
      } if (this.eapplyFormPostQDELabel.referPhoneNumber_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.referPhoneNumber_label
      }
    }
    // form_next_click(this.sharedData.cardName, 'Personal Details', labelsDisplay);
    refer_submit(this.sharedData.cardName, 'Personal Details', labelsDisplay)
    if (this.referfriendCompleteForm.invalid) {
      return;
    }
    this.friendsListObj = new friendsList();
    this.referralObj = new referralList();
    this.friendsListObj.name = this.f.fcnFullName.value;
    this.friendsListObj.emailId = this.f.fcnEmailAddress.value;
    this.friendsListObj.mobileNumber = this.f.fcnPhoneNumber.value;
    if (this.friendsList && this.friendsList.length < 3) {
      this.friendsList.push(this.friendsListObj);
    } else {
      return
    }
    if (this.sharedData.trackApplicationResponse) {
      if(this.sharedData.fromSwiftJourney){
        this.referralObj.applicationNumber = this.sharedData.trackApplicationResponse.data && this.sharedData.trackApplicationResponse.data.applicationNumber ? this.sharedData.trackApplicationResponse.data.applicationNumber : '';
        this.referralObj.firstName = this.sharedData.trackApplicationResponse.data.applicantDetails && this.sharedData.trackApplicationResponse.data.applicantDetails.firstName ? this.sharedData.trackApplicationResponse.data.applicantDetails.firstName : '';
        this.referralObj.lastName = this.sharedData.trackApplicationResponse.data.applicantDetails && this.sharedData.trackApplicationResponse.data.applicantDetails.lastName ? this.sharedData.trackApplicationResponse.data.applicantDetails.lastName : '';
        this.referralObj.referrerEmailId = this.sharedData.trackApplicationResponse.data.applicantDetails && this.sharedData.trackApplicationResponse.data.applicantDetails.personalEmailId ? this.sharedData.trackApplicationResponse.data.applicantDetails.personalEmailId : '';
        this.referralObj.referrerMobileNumber = this.sharedData.trackApplicationResponse.data.applicantDetails && this.sharedData.trackApplicationResponse.data.applicantDetails.mobileNumber ? this.sharedData.trackApplicationResponse.data.applicantDetails.mobileNumber : '';
      }
      else {
        this.referralObj.applicationNumber = this.sharedData.trackApplicationResponse && this.sharedData.trackApplicationResponse.applicationNumber ? this.sharedData.trackApplicationResponse.applicationNumber : '';
        this.referralObj.firstName = this.sharedData.trackApplicationResponse.eapplyApplicantDetails && this.sharedData.trackApplicationResponse.eapplyApplicantDetails.firstName ? this.sharedData.trackApplicationResponse.eapplyApplicantDetails.firstName : '';
        this.referralObj.lastName = this.sharedData.trackApplicationResponse.eapplyApplicantDetails && this.sharedData.trackApplicationResponse.eapplyApplicantDetails.lastName ? this.sharedData.trackApplicationResponse.eapplyApplicantDetails.lastName : '';
        this.referralObj.referrerEmailId = this.sharedData.trackApplicationResponse.eapplyApplicantDetails && this.sharedData.trackApplicationResponse.eapplyApplicantDetails.personalEmailId ? this.sharedData.trackApplicationResponse.eapplyApplicantDetails.personalEmailId : '';
        this.referralObj.referrerMobileNumber = this.sharedData.trackApplicationResponse.eapplyApplicantDetails && this.sharedData.trackApplicationResponse.eapplyApplicantDetails.mobileNumber ? this.sharedData.trackApplicationResponse.eapplyApplicantDetails.mobileNumber : '';
      }
    } else {
      this.referralObj.applicationNumber = this.sharedData.qdeSuccessResponse && this.sharedData.qdeSuccessResponse.applicationNumber ? this.sharedData.qdeSuccessResponse.applicationNumber : '';  // '2226813000021';
      this.referralObj.firstName = this.sharedData.qdeSubmitData && this.sharedData.qdeSubmitData.WSCallUserFirstName ? this.sharedData.qdeSubmitData.WSCallUserFirstName : ''; // "RAYALA";
      this.referralObj.lastName = this.sharedData.qdeSubmitData && this.sharedData.qdeSubmitData.WSCallUserLastName ? this.sharedData.qdeSubmitData.WSCallUserLastName : ''; //"GOPAL";
      this.referralObj.referrerEmailId = this.sharedData.qdeSubmitData && this.sharedData.qdeSubmitData.WSCallUserEmailId ? this.sharedData.qdeSubmitData.WSCallUserEmailId : ''; //"SMITHASHANKAR.PRABHU@SBICARD.COM";
      this.referralObj.referrerMobileNumber = this.sharedData.qdeSubmitData && this.sharedData.qdeSubmitData.WSCallUserMobileNumber ? this.sharedData.qdeSubmitData.WSCallUserMobileNumber : ''; //"9769089437";
    }
    this.referralObj.referrals = this.friendsList;
    this.referfriendCompleteForm.reset();
    reset.resetForm();
    Object.keys(this.f).forEach(key => {
      this.referfriendCompleteForm.get(key).markAsUntouched();
      this.referfriendCompleteForm.get(key).markAsPristine();
    })
  }

  deleteEmployee(list) {
    if (window['_satellite']) {
      _satellite.track("custom_link");
    }
    this.friendsList.forEach((item, index) => {
      if (list == item) {
        this.friendsList.splice(index, 1);
      }
    });
    this.validateForm(this.referfriendCompleteForm);
  }

  numberOnlyPhone(event) {
    let regex2 = /[0-9]/;
    if (event.key.match(regex2)) {
      return true;
    } else {
      return false;
    }
  }

  termsandcondition(): void {
    this.skipModalVisible = false;
    this.termsAndCondition = true;
  }

  submitReferral() {
    if (this.disableService) {
      return;
    }
    if (IS_CAMPAIGN) {
      window["page"] = 'ev_refer_family';
      window["transactionId"] = this.sharedData.amoSequeceNumber ? this.sharedData.amoSequeceNumber : '';
      AmoScript();
    }
    if (window['_satellite']) {
      _satellite.track("custom_link");
    }
    if (this.referfriendCompleteForm.invalid) {
      Object.keys(this.f).forEach(key => {
        this.referfriendCompleteForm.get(key).markAsTouched();
      });
      return;
    } else {

      if (this.referfriendCompleteForm.valid) {
        this.friendsListObj = new friendsList();
        this.referralObj = new referralList();
        this.friendsListObj.name = this.f.fcnFullName.value;
        this.friendsListObj.emailId = this.f.fcnEmailAddress.value;
        this.friendsListObj.mobileNumber = this.f.fcnPhoneNumber.value;
        if (this.friendsList && this.friendsList.length < 3) {
          this.friendsList.push(this.friendsListObj);
        }
        if (this.sharedData.trackApplicationResponse) {
          if (this.sharedData.fromSwiftJourney) {
            this.referralObj.applicationNumber = this.sharedData.trackApplicationResponse.data && this.sharedData.trackApplicationResponse.data.applicationNumber ? this.sharedData.trackApplicationResponse.data.applicationNumber : '';
            this.referralObj.firstName = this.sharedData.trackApplicationResponse.data.applicantDetails && this.sharedData.trackApplicationResponse.data.applicantDetails.firstName ? this.sharedData.trackApplicationResponse.data.applicantDetails.firstName : '';
            this.referralObj.lastName = this.sharedData.trackApplicationResponse.data.applicantDetails && this.sharedData.trackApplicationResponse.data.applicantDetails.lastName ? this.sharedData.trackApplicationResponse.data.applicantDetails.lastName : '';
            this.referralObj.referrerEmailId = this.sharedData.trackApplicationResponse.data.applicantDetails && this.sharedData.trackApplicationResponse.data.applicantDetails.personalEmailId ? this.sharedData.trackApplicationResponse.data.applicantDetails.personalEmailId : '';
            this.referralObj.referrerMobileNumber = this.sharedData.trackApplicationResponse.data.applicantDetails && this.sharedData.trackApplicationResponse.data.applicantDetails.mobileNumber ? this.sharedData.trackApplicationResponse.data.applicantDetails.mobileNumber : '';
            this.referralObj.source = 'PRELOGIN';
          }
          else {
            this.referralObj.applicationNumber = this.sharedData.trackApplicationResponse && this.sharedData.trackApplicationResponse.applicationNumber ? this.sharedData.trackApplicationResponse.applicationNumber : '';
            this.referralObj.firstName = this.sharedData.trackApplicationResponse.eapplyApplicantDetails && this.sharedData.trackApplicationResponse.eapplyApplicantDetails.firstName ? this.sharedData.trackApplicationResponse.eapplyApplicantDetails.firstName : '';
            this.referralObj.lastName = this.sharedData.trackApplicationResponse.eapplyApplicantDetails && this.sharedData.trackApplicationResponse.eapplyApplicantDetails.lastName ? this.sharedData.trackApplicationResponse.eapplyApplicantDetails.lastName : '';
            this.referralObj.referrerEmailId = this.sharedData.trackApplicationResponse.eapplyApplicantDetails && this.sharedData.trackApplicationResponse.eapplyApplicantDetails.personalEmailId ? this.sharedData.trackApplicationResponse.eapplyApplicantDetails.personalEmailId : '';
            this.referralObj.referrerMobileNumber = this.sharedData.trackApplicationResponse.eapplyApplicantDetails && this.sharedData.trackApplicationResponse.eapplyApplicantDetails.mobileNumber ? this.sharedData.trackApplicationResponse.eapplyApplicantDetails.mobileNumber : '';
            this.referralObj.source = 'PRELOGIN';
          }

        } else {
          this.referralObj.applicationNumber = this.sharedData.qdeSuccessResponse && this.sharedData.qdeSuccessResponse.applicationNumber ? this.sharedData.qdeSuccessResponse.applicationNumber : '';  // '2226813000021';
          this.referralObj.firstName = this.sharedData.qdeSubmitData && this.sharedData.qdeSubmitData.WSCallUserFirstName ? this.sharedData.qdeSubmitData.WSCallUserFirstName : ''; // "RAYALA";
          this.referralObj.lastName = this.sharedData.qdeSubmitData && this.sharedData.qdeSubmitData.WSCallUserLastName ? this.sharedData.qdeSubmitData.WSCallUserLastName : ''; //"GOPAL";
          this.referralObj.referrerEmailId = this.sharedData.qdeSubmitData && this.sharedData.qdeSubmitData.WSCallUserEmailId ? this.sharedData.qdeSubmitData.WSCallUserEmailId : ''; //"SMITHASHANKAR.PRABHU@SBICARD.COM";
          this.referralObj.referrerMobileNumber = this.sharedData.qdeSubmitData && this.sharedData.qdeSubmitData.WSCallUserMobileNumber ? this.sharedData.qdeSubmitData.WSCallUserMobileNumber : ''; //"9769089437";
          this.referralObj.source = 'PRELOGIN';
        }
        this.referralObj.referrals = this.friendsList;
      }
      if (this.referralObj) {
        console.log("Req for submitReferral ==> ", this.referralObj);
        this.referralSubscription = this.sharedData.submitReferral(this.referralObj).subscribe((result: any) => {
          if (result && result.EapplyReferralRsType && result.EapplyReferralRsType.status.toLowerCase() === 'success') {
            //AmoScript('ev_dc_start', this.sharedData.amoSequeceNumber);
            this.formValueNullFlag = true
            this.disableService = 1;
            this.friendsList && this.friendsList.length >= 1 ? this.deleteEmployee(this.friendsListObj) : true;
            this.docUploadCall();
          } else {
            this.friendsList && this.friendsList.length >= 1 ? this.deleteEmployee(this.friendsListObj) : true;
            this.errorMessageReferral = GENERIC_ERROR;
            this.disableService = 0;
            window["digitalData"].error = { message: GENERIC_ERROR };
            if (window['_satellite']) {
              _satellite.track('form_error');
            }
          }
        }, (error) => {
          this.friendsList && this.friendsList.length >= 1 ? this.deleteEmployee(this.friendsListObj) : true;
          this.errorMessageReferral = GENERIC_ERROR;
          this.disableService = 0;
          window["digitalData"].error = { message: GENERIC_ERROR };
          if (window['_satellite']) {
            _satellite.track('form_error');
          }
        });
      }
    }
    /* Analytics added */
    if (window['analytics']) {
      console.log('', this.friendsListObj);
      console.log('', this.friendsList);
      console.log('', this.friendsList[0].name);



      if (this.friendsList[0].name) {
        analytics.track('eapply__click__submit__refer_any_friend_screen', {
          'MODE_OF_CONVERSION': '',
          'IS_ORGANIC': 'N',
          'SOURCE_GEM_ID1': this.sharedData.paramsgemid1,
          'SOURCE_GEM_ID2': this.sharedData.paramsgemid2,
          'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
          'CHANNEL_NAME': this.sharedData.paramschannel,
          'JOURNEY_NAME': 'EAPPLY',
          'FIRST_NAME': this.sharedData.qdeSubmitData.WSCallUserFirstName,
          'LAST_NAME': this.sharedData.qdeSubmitData.WSCallUserLastName,
          'MIDDLE_NAME': this.sharedData.qdeSubmitData.WSCallUserMiddleName,
          'EMAIL': this.sharedData.qdeSubmitData.WSCallUserEmailId,
          'Mobile_no': this.sharedData.qdeSubmitData.WSCallUserMobileNumber,
          'CITY': this.sharedData.qdeSubmitData.WSCallUserCity,
          'COMPANY_NAME': this.sharedData.qdeSubmitData.WSCallUserCompany,
          'DOB': this.sharedData.qdeSubmitData.WSCallUserDOB,
          'DESIGNATION': this.sharedData.qdeSubmitData.WSCallUserDesignation,
          'ANNUAL_SALARY': this.sharedData.qdeSubmitData.WSCallUserAnnualIncomeValue,
          'OFFICE_PINCODE': this.sharedData.qdeSubmitData.WSCallUserOfficePincode,
          'pan': this.sharedData.qdeSubmitData.WSCallUserPanNumber,
          'RESI_ADDRESS': this.wsDetails.WSCallUserAddressLine,
          'RESI_PINCODE': this.wsDetails.WSCallUserResiPincode,
          'OCCUPATION_TYPE': this.wsDetails.WSCallUserOccupationCode,
          'CARD_TYPE': this.sharedData.sbic_card_Type,
          'refer_friend1_name': this.friendsList[0].name ? this.friendsList[0].name : this.friendsListObj.name,
          'refer_friend1_phonenumber': this.friendsList[0].mobileNumber ? this.friendsList[0].mobileNumber : this.friendsListObj.mobileNumber,
          'refer_friend1_email_id': this.friendsList[0].emailId ? this.friendsList[0].emailId : this.friendsListObj.emailId
        });
      }
      if (this.friendsList[0].name && this.friendsList[1].name) {
        analytics.track('eapply__click__submit__refer_any_friend_screen', {
          'IS_ORGANIC': 'N',
          'SOURCE_GEM_ID1': this.sharedData.paramsgemid1,
          'SOURCE_GEM_ID2': this.sharedData.paramsgemid2,
          'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
          'CHANNEL_NAME': this.sharedData.paramschannel,
          'JOURNEY_NAME': 'EAPPLY',
          'FIRST_NAME': this.sharedData.qdeSubmitData.WSCallUserFirstName,
          'LAST_NAME': this.sharedData.qdeSubmitData.WSCallUserLastName,
          'MIDDLE_NAME': this.sharedData.qdeSubmitData.WSCallUserMiddleName,
          'EMAIL': this.sharedData.qdeSubmitData.WSCallUserEmailId,
          'Mobile_no': this.sharedData.qdeSubmitData.WSCallUserMobileNumber,
          'pan': this.sharedData.qdeSubmitData.WSCallUserPanNumber,
          'DOB': this.sharedData.qdeSubmitData.WSCallUserD,
          'refer_friend1_name': this.friendsList[0].name ? this.friendsList[0].name : this.friendsListObj.name,
          'refer_friend1_phonenumber': this.friendsList[0].mobileNumber ? this.friendsList[0].mobileNumber : this.friendsListObj.mobileNumber,
          'refer_friend1_email_id': this.friendsList[0].emailId ? this.friendsList[0].emailId : this.friendsListObj.emailId,
          'refer_friend2_name': this.friendsList[1].name,
          'refer_friend2_phonenumber': this.friendsList[1].mobileNumber,
          'refer_friend2_email_id': this.friendsList[1].emailId,

        });
      }
      if (this.friendsList[0].name && this.friendsList[1].name && this.friendsList[2].name) {
        analytics.track('eapply__click__submit__refer_any_friend_screen', {
          'IS_ORGANIC': 'N',
          'SOURCE_GEM_ID1': this.sharedData.paramsgemid1,
          'SOURCE_GEM_ID2': this.sharedData.paramsgemid2,
          'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
          'CHANNEL_NAME': this.sharedData.paramschannel,
          'JOURNEY_NAME': 'EAPPLY',
          'FIRST_NAME': this.sharedData.qdeSubmitData.WSCallUserFirstName,
          'LAST_NAME': this.sharedData.qdeSubmitData.WSCallUserLastName,
          'MIDDLE_NAME': this.sharedData.qdeSubmitData.WSCallUserMiddleName,
          'EMAIL': this.sharedData.qdeSubmitData.WSCallUserEmailId,
          'Mobile_no': this.sharedData.qdeSubmitData.WSCallUserMobileNumber,
          'pan': this.sharedData.qdeSubmitData.WSCallUserPanNumber,
          'DOB': this.sharedData.qdeSubmitData.WSCallUserDOB,
          'refer_friend1_name': this.friendsList[0].name ? this.friendsList[0].name : this.friendsListObj.name,
          'refer_friend1_phonenumber': this.friendsList[0].mobileNumber ? this.friendsList[0].mobileNumber : this.friendsListObj.mobileNumber,
          'refer_friend1_email_id': this.friendsList[0].emailId ? this.friendsList[0].emailId : this.friendsListObj.emailId,
          'refer_friend2_name': this.friendsList[1].name,
          'refer_friend2_phonenumber': this.friendsList[1].mobileNumber,
          'refer_friend2_email_id': this.friendsList[1].emailId,
          'refer_friend3_name': this.friendsList[2].name,
          'refer_friend3_phonenumber': this.friendsList[2].mobileNumber,
          'refer_friend3_email_id': this.friendsList[2].emailId,

        });
      }


    }

  }

  validateForm(obj) {
    if (this.referfriendCompleteForm.invalid) {
      this.formValueNullFlag = true
      if ((obj.fcnFullName == null || obj.fcnFullName == '') &&
        (obj.fcnEmailAddress == null || obj.fcnEmailAddress == '') &&
        (obj.fcnPhoneNumber == null || obj.fcnPhoneNumber == '')) {
        if (this.friendsList && this.friendsList.length) {
          this.formValueNullFlag = false
        }
      }
    } else if (this.referfriendCompleteForm.valid) {
      this.formValueNullFlag = false
    }

  }

  docUploadCall() {
    let channel: any;
    let appNumber: any;
    let data = window['digitalData'];
    if (this.sharedData.trackApplicationResponse) {
      if(this.sharedData.fromSwiftJourney){
        channel = this.sharedData.trackApplicationResponse.data.channelCode;
      }
      else {
        channel = this.sharedData.trackApplicationResponse.channelCode;
      }
    } else {
      channel = this.sharedData.qdeSubmitData && this.sharedData.qdeSubmitData.WSCallChannelCode ? this.sharedData.qdeSubmitData.WSCallChannelCode : null;
    }

    if (channel === 'EALB' || this.sharedData.paramschannel == '901' || sessionStorage.getItem('channelId') == '901') {
      data.page = { pageName: 'sbi-card:banca doc-upload:campaign', pageType: 'Banca' };
    } else if (IS_CAMPAIGN) {
      data.page = { pageName: 'sbi-card:eapply doc-upload:campaign', pageType: 'Campaign' };
    } else if (this.sharedData.paramsshortCode || sessionStorage.getItem('sc')) {
      data.page = { pageName: 'sbi-card:reapply doc-upload:reapply', pageType: 'reapply' };
    } else {
      data.page = { pageName: 'sbi-card:eapply doc-upload:eapplyform', pageType: 'Eapply' };
    }
    sessionStorage.setItem('digitalData', JSON.stringify(data));
    if (this.sharedData.navigateToDocUpload && (this.containerType && this.partnerCode)) {
      if (this.sharedData.trackApplicationResponse) {
        if(this.sharedData.fromSwiftJourney) {
          sessionStorage.setItem('trackResponse', JSON.stringify(this.sharedData.trackApplicationResponse));
          appNumber = this.sharedData.trackApplicationResponse.data.applicationNumber;
          sessionStorage.setItem('appNo', this.sharedData.trackApplicationResponse.data.applicationNumber);
        }
        else {
          sessionStorage.setItem('trackResponse', JSON.stringify(this.sharedData.trackApplicationResponse));
          appNumber = this.sharedData.trackApplicationResponse.applicationNumber;
          sessionStorage.setItem('appNo', this.sharedData.trackApplicationResponse.applicationNumber);
        }
      } else {
        sessionStorage.setItem('offAdd', JSON.stringify(this.sharedData.cAprofessisonalData));
        sessionStorage.setItem('currentAdd', JSON.stringify(this.sharedData.qdeSubmitData));
        sessionStorage.setItem('perAdd', JSON.stringify(this.sharedData.cApersonalData));
        sessionStorage.setItem('qdeResponseFlags', JSON.stringify(this.sharedData.flagsFromQdeResponse));
        sessionStorage.setItem('appNo', this.sharedData.qdeSuccessResponse.applicationNumber);
        sessionStorage.setItem('applicantName', this.sharedData.applicantName);
        appNumber = this.sharedData.qdeSuccessResponse.applicationNumber
        sessionStorage.setItem('officeCity', this.sharedData.officeCity);
        sessionStorage.setItem('officeState', this.sharedData.officeState);
        sessionStorage.setItem('resiState', this.sharedData.resiState);
        sessionStorage.setItem('cardName', this.sharedData.cardName);
        sessionStorage.setItem('cardType', this.sharedData.sbic_card_Type);
      }

      this.router.navigate(['/', 'schedule-appointment'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
      this.dialog.closeAll();
    } else if (this.sharedData.navigateToDocUpload) {
      if (this.sharedData.trackApplicationResponse) {
        if(this.sharedData.fromSwiftJourney) {
          sessionStorage.setItem('trackResponse', JSON.stringify(this.sharedData.trackApplicationResponse));
          appNumber = this.sharedData.trackApplicationResponse.data.applicationNumber;
          sessionStorage.setItem('appNo', this.sharedData.trackApplicationResponse.data.applicationNumber);
        }
        else {
          sessionStorage.setItem('trackResponse', JSON.stringify(this.sharedData.trackApplicationResponse));
          appNumber = this.sharedData.trackApplicationResponse.applicationNumber;
          sessionStorage.setItem('appNo', this.sharedData.trackApplicationResponse.applicationNumber);
        }
      } else {
        sessionStorage.setItem('offAdd', JSON.stringify(this.sharedData.cAprofessisonalData));
        sessionStorage.setItem('currentAdd', JSON.stringify(this.sharedData.qdeSubmitData));
        sessionStorage.setItem('perAdd', JSON.stringify(this.sharedData.cApersonalData));
        sessionStorage.setItem('qdeResponseFlags', JSON.stringify(this.sharedData.flagsFromQdeResponse));
        sessionStorage.setItem('appNo', this.sharedData.qdeSuccessResponse.applicationNumber);
        sessionStorage.setItem('applicantName', this.sharedData.applicantName);
        appNumber = this.sharedData.qdeSuccessResponse.applicationNumber
        sessionStorage.setItem('officeCity', this.sharedData.officeCity);
        sessionStorage.setItem('officeState', this.sharedData.officeState);
        sessionStorage.setItem('resiState', this.sharedData.resiState);
        sessionStorage.setItem('cardName', this.sharedData.cardName);
        sessionStorage.setItem('cardType', this.sharedData.sbic_card_Type);
      }

      let requestApp = {
        "applicationNumber": appNumber
      }
      this.sharedData.getExpandUrlForDocUplod(requestApp).subscribe((response: any) => {
        console.log("fetch params from skip popup component 535");
        if (window['_satellite']) {
          _satellite.track("doc_upload");
        }
        const res = { ...response.body }
        console.log("response540" + res);
        if (res && res.FetchDocUploadParamsRsType && res.FetchDocUploadParamsRsType.status) {
          let accessToken: any;
          let expiryTime: any;
          if (response.headers && response.headers.get("access_token")) {
            accessToken = response.headers.get("access_token");
          }
          if (response.headers && response.headers.get("expiry_time")) {
            expiryTime = response.headers.get("expiry_time");
          }

          if (accessToken) {
            sessionStorage.setItem("s24_access_token", accessToken);
          }
          if (expiryTime) {
            sessionStorage.setItem("s24_expiry_time", expiryTime);
          }
          sessionStorage.setItem('eAppId', res.FetchDocUploadParamsRsType.applicationId);
          sessionStorage.setItem('eVerificationCode', res.FetchDocUploadParamsRsType.verificationCode);
          const docUploadStatus = res.FetchDocUploadParamsRsType.docUploadStatusFlag;
          console.log("docuploadstatus560"+ docUploadStatus);
          console.log("navigate561"+ this.sharedData.navigateToDocUpload);
          if (docUploadStatus == 'Y' || docUploadStatus == 'N' || docUploadStatus == 'D') {
            this.sharedData.navigateToDocUpload = false;
            console.log("in if block564" + docUploadStatus);
            if(this.sharedData.fromSwiftJourney){
              console.log("inswifyjourney");
              console.log("navigate"+ this.sharedData.navigateToDocUpload);
              console.log("568" + this.sharedData.trackApplicationResponse);
              console.log("569" + this.sharedData.trackApplicationResponse.data.enableAppointmentFlag);
              console.log("570" + this.sharedData.trackApplicationResponse.data.enableReSchdAppointmentFlag);
              if (this.sharedData.trackApplicationResponse && (this.sharedData.trackApplicationResponse.data.enableAppointmentFlag || this.sharedData.trackApplicationResponse.data.enableReSchdAppointmentFlag)) {
                console.log("inside if 572" + this.sharedData.trackApplicationResponse);
                this.router.navigate(['/', 'schedule-appointment'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
                this.dialog.closeAll();
              } else if (this.sharedData.trackApplicationResponse && ((this.sharedData.trackApplicationResponse.data.enableAddOnListFlag) || (this.sharedData.trackApplicationResponse.data.enableCrossSellFlag))) {
                this.router.navigate(['/', 'addon-card'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
                this.dialog.closeAll();
              } else {
                this.router.navigate(['/', 'success'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
                this.dialog.closeAll();
              }
            }
            else {
              console.log("In eapply journey 584");
              if (this.sharedData.trackApplicationResponse && (this.sharedData.trackApplicationResponse.enableAppointmentFlag || this.sharedData.trackApplicationResponse.enableReSchdAppointmentFlag)) {
                this.router.navigate(['/', 'schedule-appointment'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
                this.dialog.closeAll();
              } else if (this.sharedData.trackApplicationResponse && ((this.sharedData.trackApplicationResponse.enableAddOnListFlag) || (this.sharedData.trackApplicationResponse.enableCrossSellFlag))) {
                this.router.navigate(['/', 'addon-card'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
                this.dialog.closeAll();
              } else {
                this.router.navigate(['/', 'success'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
                this.dialog.closeAll();
              }
            }
            
          } else if (docUploadStatus == 'I' || docUploadStatus == '') {
            console.log("else if part 598" + docUploadStatus);
            this.sharedData.navigateToDocUpload = true;
            this.createHiddenForm();
          }
          console.log("before createhidden method");
          // this.createHiddenForm();
        } else {
          this.disableService = 0;
          window["digitalData"].error = { message: GENERIC_ERROR };
          if (window['_satellite']) {
            _satellite.track('form_error');
          }
          return this.createHiddenForm();
        }
      }, err => {
        this.disableService = 0;
        window["digitalData"].error = { message: GENERIC_ERROR };
        if (window['_satellite']) {
          _satellite.track('form_error');
        }
        return this.createHiddenForm();
      });
    } else if (this.sharedData.fromSwiftJourney ? (this.sharedData.trackApplicationResponse && (this.sharedData.trackApplicationResponse.data.enableAppointmentFlag || this.sharedData.trackApplicationResponse.data.enableReSchdAppointmentFlag)) : (this.sharedData.trackApplicationResponse && (this.sharedData.trackApplicationResponse.enableAppointmentFlag || this.sharedData.trackApplicationResponse.enableReSchdAppointmentFlag))) {
      this.router.navigate(['/', 'schedule-appointment'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
      this.dialog.closeAll();
    } else if (this.sharedData.fromSwiftJourney ? (this.sharedData.trackApplicationResponse && ((this.sharedData.trackApplicationResponse.data.enableAddOnListFlag) || (this.sharedData.trackApplicationResponse.data.enableCrossSellFlag))) :(this.sharedData.trackApplicationResponse && ((this.sharedData.trackApplicationResponse.enableAddOnListFlag) || (this.sharedData.trackApplicationResponse.enableCrossSellFlag)))) {
      this.router.navigate(['/', 'addon-card'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
      this.dialog.closeAll();
    } else {
      this.router.navigate(['/', 'success'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
      this.dialog.closeAll();
    }
  }

  createHiddenForm() {
    var form = document.createElement("form");
    form.method = "POST";
    form.action = DOC_UPLOAD_LINK;
    document.body.appendChild(form);
    form.submit();
  }

  ngOnDestroy() {
    if (this.referralSubscription) {
      this.referralSubscription.unsubscribe();
    }
  }

}
